import React from "react";
import { Table } from "react-bootstrap";
import { Link } from "react-router-dom";

import classNames from "classnames";

import { useRosterContext } from "../contexts/Roster";
import calculateDateAdded from "../lib/calculateDateAdded";
import isPlayoffEligible from "../lib/isPlayoffEligible";

import { defaultDateFormat } from "../../../../../lib/utils";

const CoachView = (): React.JSX.Element => {
    const {
        roster,
        currentTeam,
        currentTeamsLeague,
        currentTeamAgeLevel,
        currentYear,
        playoffEligibileDate,
    } = useRosterContext();

    return (
        <Table
            data-testid="coachView"
            striped
            className={classNames("teamRoster")}
            responsive
        >
            <thead>
                <tr>
                    <th></th>
                    <th>Status</th>
                    <th>Name</th>
                    <th>#</th>
                    <th>DOB</th>
                    <th>Email</th>
                    <th>Date Added</th>
                    <th>Waiver Date Accepted</th>
                    <th>Primary Team?</th>
                    <th>Playoff Eligible</th>
                </tr>
            </thead>
            <tbody>
                {roster.map(p => (
                    <tr key={p.id}>
                        <td>
                            <Link
                                to={`/coachs-clubhouse/team/${currentTeam?.id}/roster/edit/${p.id}`}
                                className="btn btn-primary"
                            >
                                Edit
                            </Link>
                        </td>
                        <td>{p.active === 1 ? "Active" : "Inactive"}</td>
                        <td>{`${p.firstName} ${p.lastName}`}</td>
                        <td>{p.uniformNumber}</td>
                        <td>
                            {p.dob
                                ? defaultDateFormat.format(
                                      new Date(`${p.dob}T00:00:00`),
                                  )
                                : ""}
                        </td>
                        <td>{p.email}</td>
                        <td>
                            {calculateDateAdded(
                                p,
                                currentTeam,
                                currentTeamAgeLevel,
                            )}
                        </td>
                        <td>
                            {p.waiverYear && p.waiverAccepted
                                ? p.waiverYear === currentYear
                                    ? defaultDateFormat.format(
                                          new Date(p.waiverAccepted),
                                      )
                                    : "None"
                                : "None"}
                        </td>
                        <td>
                            {p.teams.find(t => {
                                if (currentTeamsLeague) {
                                    return t.year === currentTeamsLeague.year;
                                } else {
                                    return t.year === currentTeamAgeLevel?.year;
                                }
                            })?.primary?.id === currentTeam?.id
                                ? "Yes"
                                : "No"}
                        </td>
                        <td>
                            {isPlayoffEligible(
                                p,
                                currentYear,
                                playoffEligibileDate,
                            )
                                ? "Yes"
                                : "No"}
                        </td>
                    </tr>
                ))}
            </tbody>
        </Table>
    );
};

export default CoachView;
